import { useState, useEffect } from "react";
import { Navbar, fetchWithTimeout, pageStyle, mainContentStyle, cardStyle } from "../App";

const API_URL = process.env.REACT_APP_API_URL;

function Contact() {
  const [waNumber, setWaNumber] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWithTimeout(`${API_URL}/settings/whatsapp_number`)
      .then(r => r.json())
      .then(data => {
        if (data.value) setWaNumber(data.value);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="mama-page" style={pageStyle}>
      <Navbar />
      <div className="mama-main" style={mainContentStyle}>
        <div className="mama-card" style={{ ...cardStyle, maxWidth: "440px", margin: "0 auto", textAlign: "center", padding: "2.5rem 2rem" }}>
          <div style={{ fontSize: "3.5rem", marginBottom: "0.5rem" }}>💬</div>
          <h1 className="mama-heading" style={{ marginBottom: "0.5rem", fontSize: "1.5rem" }}>
            Got a question?
          </h1>
          <p style={{ color: "var(--text-muted)", lineHeight: 1.7, marginBottom: "1.75rem", fontSize: "0.95rem" }}>
            If you need help with your order, want to ask about the menu, or just have a question — send me a message on WhatsApp. I'll get back to you as soon as I can!
          </p>

          {loading ? (
            <p style={{ color: "var(--text-muted)" }}>Loading...</p>
          ) : waNumber ? (
            <>
              <a
                href={`https://wa.me/${waNumber}`}
                target="_blank"
                rel="noreferrer"
                className="mama-wa-btn"
              >
                <span style={{ fontSize: "1.2rem" }}>📱</span>
                Message me on WhatsApp
              </a>
              <p style={{ marginTop: "1.25rem", fontSize: "0.82rem", color: "var(--text-muted)" }}>
                Opens WhatsApp — you can ask me anything there.
              </p>
            </>
          ) : (
            <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>
              Contact not set up yet — check back soon.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;
